import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import VideoPreview from "./VideoPreview.vue";
export default {
  name: "MsgList",
  components: {
    VideoPreview: VideoPreview
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    },
    status: {
      type: Number,
      default: 0
    },
    info: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      previewVideoUrl: "",
      imgArr: [],
      tableData: [],
      imgIndex: 0,
      pagination: {
        pageNum: 1,
        pageSize: 5
      }
    };
  },
  computed: {
    closeTitle: function closeTitle() {
      var _this$info = this.info,
        closeType = _this$info.closeType,
        closeUserName = _this$info.closeUserName;
      var title = '咨询由系统自动关闭';
      if (closeType === 'user') {
        title = '咨询由用户自行关闭';
      } else if (closeType === 'follow') {
        title = "\u54A8\u8BE2\u7531\u8FD0\u8425-".concat(closeUserName || '', "\u5173\u95ED");
      }
      return title;
    }
  },
  watch: {
    list: {
      handler: function handler(nVal) {
        this.tableData = this.currentChangePage(this.pagination.pageSize, this.pagination.pageNum);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    previewImage: function previewImage(index, imgIndex, arr) {
      var _this = this;
      this.imgArr = arr;
      this.$nextTick(function () {
        var _this$$refs;
        (_this$$refs = _this.$refs["image_".concat(index)]) === null || _this$$refs === void 0 || _this$$refs[imgIndex].handleClick(imgIndex);
      });
    },
    previewVideo: function previewVideo(url) {
      this.previewVideoUrl = url;
      this.$refs.videoPreview.show();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1;
      this.tableData = this.currentChangePage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.tableData = this.currentChangePage();
    },
    // 分页方法
    currentChangePage: function currentChangePage() {
      var size = this.pagination.pageSize;
      var current = this.pagination.pageNum;
      var tablePush = [];
      this.list.forEach(function (item, index) {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    }
  }
};